import { render, staticRenderFns } from "./FaceberryPrintCard.vue?vue&type=template&id=01af92aa&scoped=true"
import script from "./FaceberryPrintCard.vue?vue&type=script&lang=js"
export * from "./FaceberryPrintCard.vue?vue&type=script&lang=js"
import style0 from "./FaceberryPrintCard.vue?vue&type=style&index=0&id=01af92aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af92aa",
  null
  
)

export default component.exports